import axios from "axios";
import { api_urls } from "../../utilities";
import { getAuthorizationHeader } from "./authHeader";

export const deleteService = (api) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
  };

  return axios
    .delete(api_urls.base_url + api, config)
    .then((res) => res)
    .catch((error) => {
      throw error.response || error;
    });
};
